import { createTheme } from '@mui/material/styles';

const baTheme = createTheme({
    palette: {
      primary: {
        main: '#C1D2EC',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#848484',
        contrastText: '#000000',
      },
      info: {
        main: '#2cabe3',  // Add this to match your CSS variable
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
    },
    components: {
      MuiLink: {
        styleOverrides: {
          root: {
            color: '#2cabe3',  // Default color for all MuiLinks
            '&:hover': {
              color: '#1a9bd4',  // slightly darker on hover
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            backgroundColor: '#001f3f',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#000d1a',
            },
          },
        },
      },
    },
  });

export default baTheme;